import { Component, inject, Input, OnInit } from '@angular/core';
import { BrokerStylingService } from 'src/app/services/broker-styling.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit{
  
  private brokerStylingService = inject(BrokerStylingService)
  @Input() brokerId: string = ''

  broker
  journeyGuideUrl = ''

  ngOnInit(): void {
    this.broker = this.brokerStylingService.getBrokerDetailFromDomain()
    this.journeyGuideUrl = this.isRetrievePage()
      ? this.broker.retrieveJourneyGuideUrl ?? this.broker.journeyGuideUrl
      : this.broker.journeyGuideUrl
  }

  private isRetrievePage(): boolean {
    return window.location.pathname.startsWith('/retrieve')
  }
}
